import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { SplashDialogComponent } from "./splash-dialog.component";
import { SplashDialogService } from "./splash-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatProgressBarModule,
    ],

    declarations: [SplashDialogComponent],
    exports: [SplashDialogComponent],
    providers: [SplashDialogService],
})
export class SplashDialogModule {}